import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import PeopleData from '../../services/people-service';
import './people.css';
import toast from 'react-hot-toast';

export const People = ({ accessToken }) => {
  const [data, setData] = useState(null);
  const [currentAccessToken, setCurrentAccessToken] = useState(null);

  const deletePerson = async (event) => {
    const id = event.target.value;
    console.log("ID: " + id);
    try {
      if ( confirm( "Are you sure you want to delete this person?") ) {
        await PeopleData.deletePerson(id, currentAccessToken);
        const newData = await PeopleData.getData(currentAccessToken);
        setData(newData);
        toast.success("Successfully deleted person.")
      }
    } catch (error) {
      toast.error("Failed to delete person");
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (accessToken) {
        const fetchedData = await PeopleData.getData(accessToken);
        setData(fetchedData);
        setCurrentAccessToken(accessToken);
      }
    };
    fetchData();
  }, [accessToken]);

  const filterUsers = (user, data) => {
    console.log("Filtering for user: " + user);
    return data.filter(function(data) { 
      return data.personID === user;
    });
  };

  if (!currentAccessToken) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return (
      <div>
        <h1>Create Person:</h1>
        <CreatePersonForm 
          onDataUpdate={setData} 
          accessToken={currentAccessToken} 
        />
        <BulkCreatePersonForm 
          onDataUpdate={setData}
          accessToken={currentAccessToken} />
        <hr />
        <div>No Data</div>
      </div>
    );
  }

  const rows = [];
  let personCount = 0;

  for (let i = 0; i < data.length; i++) {
    const personLink = "/people/" + data[i].id;
    rows.push(
      <tr key={data[i].id}>
        <td>
          <Link to={{ pathname: personLink }}>
            {data[i].givenName}
          </Link>
        </td>
        <td>{data[i].surname}</td>
        <td>{data[i].email}</td>
        <td>
          <button
            type="button"
            onClick={deletePerson}
            value={data[i].id}
            className="btn btn-primary btn-block contact"
          >
            Delete
          </button>
        </td>
      </tr>
    );
    personCount++;
  }

  return (
    <div>
      <h1>Create Person:</h1>
      <CreatePersonForm 
        onDataUpdate={setData} 
        accessToken={currentAccessToken} 
      />
      <BulkCreatePersonForm 
        onDataUpdate={setData}
        accessToken={currentAccessToken} />
      <hr />
      <h1>Manage People:</h1>
      <table>
        <tbody>
          <tr>
            <td>First Name</td>
            <td>Last Name</td>
            <td>Email Address</td>
            <td>Manage</td>
          </tr>
          {rows}
        </tbody>
      </table>
    </div>
  );
};

export const BulkCreatePersonForm = ({ onDataUpdate, accessToken }) => {
  const [statusList, setStatusList] = useState([]);

  useEffect(() => {
    setStatusList([]);
  }, [accessToken]);

  const handleBulkSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    const userData = data.get('bulk');
    const userItems = userData.split("\n");

    // Initialize status list
    const initialStatusList = [];
    for (let x = 0; x < userItems.length; x++) {
      const userItem = userItems[x].split(",");
      const formData = {
        givenName: userItem[0],
        surname: userItem[1],
        email: userItem[2],
        status: "grey"
      };
      initialStatusList.push(formData);
    }
    setStatusList(initialStatusList);

    // Process each user
    for (let i = 0; i < userItems.length; i++) {
      const userItem = userItems[i].split(",");
      const formData = {
        givenName: userItem[0],
        surname: userItem[1],
        email: userItem[2]
      };

      const itemIndex = i;
      console.log("ID out : " + itemIndex);
      try {
        await PeopleData.createPerson(formData, accessToken);
        setStatusList(prevStatusList => {
          const updatedStatus = [...prevStatusList];
          updatedStatus[itemIndex].status = "#99ff99"; // light green websafe
          console.log(JSON.stringify(updatedStatus));
          return updatedStatus;
        });
      } catch (error) {
        alert(error);
      }
    }
    const newData = await PeopleData.getData(accessToken);
    onDataUpdate(newData);
    console.log(JSON.stringify(userItems));
  };

  if (statusList && statusList.length > 0) {
    const rows = [];
    rows.push(<tr><td>First Name</td><td>Last Name</td><td>Email Address</td></tr>)
    for (let i = 0; i < statusList.length; i++) {
      rows.push(
        <tr key={i} style={{ backgroundColor: statusList[i].status }}>
          <td>{statusList[i].givenName}</td>
          <td>{statusList[i].surname}</td>
          <td>{statusList[i].email}</td>
        </tr>
      );
    }
    return (
      <>
        <h1>Bulk-Creating People...</h1>
        <p>When all rows below show green, the bulk load of people has been completed.</p>
        <table>
          <tbody>{rows}</tbody>
        </table>
      </>
    );
  }

  return (
    <div>
      <hr />
      <h1>Bulk Load People</h1>
      <p>You can load multiple people into the application by using comma delimited entries below</p>
      <p>Example:</p>
      <p>
      <i>John, Doe, jd@somewhere.com</i><br />
      <i>Jane, Doe, jane.doe@somewhere.com</i>
      </p>
      <form className="form-horizontal" onSubmit={handleBulkSubmit}>
        <textarea
          className="bulk-textarea"
          name="bulk"
          id="bulk"
        />
        <br />
        <button
          type="submit"
          id="bulkSubmit"
          className="btn btn-primary btn-block contact"
        >
          Submit Bulk Load
        </button>
      </form>
    </div>
  );
};

export const CreatePersonForm = ({ onDataUpdate, accessToken }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [givenName, setGivenName] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsButtonDisabled(true);
    
    const data = new FormData(event.target);
    const formData = {
      email: data.get('fromEmail'),
      givenName: data.get('givenName'),
      surname: data.get('surname')
    };

    try {
      await PeopleData.createPerson(formData, accessToken);
      toast.success('Successfully created ' + formData.givenName);
      const newData = await PeopleData.getData(accessToken);
      onDataUpdate(newData);
      
      setIsButtonDisabled(false);
      setSurname('');
      setGivenName('');
      setEmail('');
    } catch (error) {
      console.log("Fail - " + error);
      toast.error("Failed to create user");
      setIsButtonDisabled(false);
    }
  };

  const filterUsers = (user, data) => {
    console.log("Filtering for user: " + user);
    return data.filter(function(data) { 
      return data.personID === user;
    });
  };

  return (
    <div>
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <div className="form-group padding-10">
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              id="givenName"
              placeholder="First Name"
              name="givenName"
              value={givenName}
              onChange={(e) => setGivenName(e.target.value)}
            />
          </div>
          <div className="col-sm-6">
            <input
              type="text"
              className="form-control"
              id="surname"
              placeholder="Last name"
              name="surname"
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <input
              type="email"
              className="form-control"
              id="fromEmail"
              placeholder="Email (Optional)"
              name="fromEmail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-md-12">
            <button
              type="submit"
              id="singlePersonCreate"
              disabled={isButtonDisabled}
              className="btn btn-primary btn-block contact"
            >
              Create Person
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};